module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/ja-技术研发.e6705926.png";